import UnoCaptchaComponent from "./components/UnoCaptchaComponent"
import {showJcaptcha, hideJcaptcha, refreshJcaptcha} from "./actions/unoCaptcha"
import {unoCaptcha} from "./reducers/unoCaptcha"

const UnoCaptcha = {
    UnoCaptchaComponent,
    actions: {showJcaptcha, hideJcaptcha, refreshJcaptcha},
    reducer: unoCaptcha
};

export default UnoCaptcha;